import 'css-chunk:src/components/ToggleSwitch/ToggleSwitch.module.scss';export default {
  "ToggleSwitch": "ToggleSwitch-module__ToggleSwitch___-Pyhf",
  "smooth": "ToggleSwitch-module__smooth___MGRM1"
};